import {
  MONTHLY_REVIEW,
  SIDEBAR_OPEN,
  TEST_VALUE,
  USER_GUIDES,
  USER_PLAN,
} from "./queries"

import { gql } from "@apollo/client"
import log from "../utils/log"
import cache from "./cache"
import { ENTRY } from "./fields"

export const typeDefs = gql`
  extend type Query {
    sidebarOpen: Boolean!
    cartItems: [ID!]!
    testValue: TestValue
  }

  extend type Mutation {
    addOrRemoveFromCart(id: ID!): [Launch]
    isPremiumUser: Boolean
    toggleSidebar: Boolean
    updateMonthlyReview(data: MonthlyReviewData): MonthlyReviewData
    setTestValue: TestValue
  }

  extend type Launch {
    isInCart: Boolean!
  }

  extend type UserEntry {
    key: String
    date: String
    type: String
    text: String
    image: String
    pinned: Boolean
    month: String
    year: String
    review: String
    tags: [String]
    reflection: String
    __typename: String
  }

  extend type LowlightReview {
    question: String
    questionResponse: String
    note: String
  }

  extend type RankingTypeReview {
    rank: Number
    note: String
    __typename: String
  }

  extend type RankingsReview {
    mind: RankingTypeReview
    body: RankingTypeReview
    soul: RankingTypeReview
    play: RankingTypeReview
    love: RankingTypeReview
    __typename: String
  }

  extend type MonthlyReviewData {
    id: String
    draft: Boolean
    date: String
    month: String
    year: Strings
    highlightsNote: String
    lowlightsNotes: [LowlightReview]
    rankings: RankingsReview
    summarize: String
    forward: String
    saved: String
    entries: [UserEntry]
    __typename: String
  }

  extend type TestValue {
    a: String
    b: String
    __typename: String
  }
`
// https://www.apollographql.com/docs/tutorial/local-state/#local-resolvers
export const resolvers = {
  Query: {
    userGuides: (_, __, { cache }, info) => {
      const data = {
        userGuides: {
          monthly: [],
          yearly: [],
        },
      }
      cache.writeQuery({ query: USER_GUIDES, data })
      return data.userGuides
    },
    userEntries: (_, { key }, { cache: _cache }, info) => {
      const query = cache.readPartialDocument({
        id: key,
        fragment: gql`
          fragment ResolveUserEntriesFromCache on UserEntry {
            ${ENTRY}
          }
        `,
      })
      console.log("LOG: QUERY", query)
      return query
    },
  },
  Mutation: {
    setTestValue: (_, { a, b }, { cache }) => {
      // const { testValue } = cache.readQuery({ query: TEST_VALUE })
      const data = {
        testValue: {
          a,
          b,
          __typename: "TestValue",
        },
      }
      cache.writeQuery({ query: TEST_VALUE, data })
      return data.testValue
    },
    toggleSidebar: (_, __, { cache }) => {
      const { sidebarOpen } = cache.readQuery({ query: SIDEBAR_OPEN })
      const data = {
        sidebarOpen: !sidebarOpen,
      }
      cache.writeQuery({ query: SIDEBAR_OPEN, data })
      return data.sidebarOpen
    },
    setToPremiumUser: (_, __, { cache }) => {
      const data = {
        isPremiumUser: true,
      }
      cache.writeQuery({ query: USER_PLAN, data })
      return data.isPremiumUser
    },
    updateMonthlyReview: (_, { data }, { cache }) => {
      log("log", ["Resolver: updateMonthlyReview evoked", data])
      const { monthlyReview } = cache.readQuery({ query: MONTHLY_REVIEW })
      const update = {
        monthlyReview: {
          ...monthlyReview,
          ...data,
        },
      }
      log("log", [
        "Resolver: updateMonthlyReviewData",
        { monthlyReview, data, update },
      ])
      cache.writeQuery({ query: MONTHLY_REVIEW, update })
      return {
        success: true,
        data: update.monthlyReview,
      }
    },
  },
}
